import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalSupplierRow } from 'src/app/models/suppliers/global-supplier.model';
import { GlobalSupplierService } from 'src/app/services/global-supplier/global-supplier.service';
import { assetUrl } from 'src/app/services/utilities';
import { GridSelectColumn } from 'src/app/shared/components/grid-select-box/grid-select-box.component';

@Component({
  selector: 'app-global-supplier-selector',
  templateUrl: './global-supplier-selector.component.html',
  styleUrls: ['./global-supplier-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GlobalSupplierSelectorComponent implements OnInit, OnDestroy {
  public logoOV = assetUrl('img/overview_IS.png');
  public logoSN = assetUrl('img/selfnet_IS.png');
  public current: GlobalSupplierRow = null;
  public selectedKey: string = null;
  public noDataText = 'Caricamento reti...';

  public readonly columns: GridSelectColumn[] = [
    { dataField: 'code', caption: 'Codice', width: 100 },
    { dataField: 'overview_name', caption: 'Rete Overview', icon: { src: this.logoOV, field: 'overview' } },
    { dataField: 'selfnet_name', caption: 'Rete Selfnet', icon: { src: this.logoSN, field: 'selfnet' } },
  ];

  private subscription: Subscription;

  constructor(public globalSupplierService: GlobalSupplierService) { }

  ngOnInit() {
    this.subscription = this.globalSupplierService.current.subscribe((row) => {
      this.current = row;
      this.selectedKey = row?.key ?? null;
    });

    this.globalSupplierService.loadSuppliers().then(() => {
      this.noDataText = 'Nessuna rete disponibile';
    });
  }

  /** Suppliers of the service, reloaded also by the pages that edit them */
  get rows(): GlobalSupplierRow[] {
    return this.globalSupplierService.rows;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  /**
   * Selection or clear of the user: change the global supplier, or remove it
   * @param e selected value and row
   */
  onSelectionChanged(e: { value: string; row: GlobalSupplierRow }) {
    this.globalSupplierService.changeSupplier(e.row);
  }

  /**
   * Return the string to display in dropdown menu for supplier item
   * @param row Selected item.
   */
  displayExpr(row: GlobalSupplierRow): string {
    return GlobalSupplierService.description(row);
  }
}
